import BSkeleton from 'components/common/BSkeleton';
import { FunctionComponent, useEffect, useState } from 'react';
import { dateService } from 'services/DateService';
import { experienceService } from 'services/ExperienceService';
import { ExperienceDetail } from 'types/experience/experience-detail.type';
import { ExperienceSession } from 'types/experience/experience-session.type';
import ExperiencePriceWidgetBody from './ExperiencePriceWidgetBody';
import ExperiencePriceWidgetDesktop from './ExperiencePriceWidgetDesktop';
import ExperiencePriceWidgetMobile from './ExperiencePriceWidgetMobile';

export interface ExperienceDetailPriceWidgetProps {
  experience: ExperienceDetail;
}

const ExperienceDetailPriceWidget: FunctionComponent<
  ExperienceDetailPriceWidgetProps
> = ({ experience }) => {
  const [loading, setLoading] = useState<boolean>(false);
  const [sessions, setSessions] = useState<ExperienceSession[]>([]);

  const getSessions = async () => {
    setLoading(true);
    const startDate = dateService.formatDateToServerDateString(new Date());
    try {
      const res = await experienceService.getExperienceSessions(experience.id, {
        startDate: startDate,
      });
      setSessions(res.content);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getSessions();
  }, []);

  return (
    <>
      <ExperiencePriceWidgetDesktop>
        {loading ? (
          <BSkeleton className="h-8 w-48" />
        ) : (
          <ExperiencePriceWidgetBody
            experience={experience}
            sessions={sessions}
          />
        )}
      </ExperiencePriceWidgetDesktop>
      <ExperiencePriceWidgetMobile
        sessions={sessions}
        sessionsLoading={loading}
      >
        {loading ? (
          <BSkeleton className="h-8 w-48" />
        ) : (
          <ExperiencePriceWidgetBody
            experience={experience}
            sessions={sessions}
            isMobile
          />
        )}
      </ExperiencePriceWidgetMobile>
    </>
  );
};

export default ExperienceDetailPriceWidget;
